<template>
	<!-- Main sidebar -->
    <div class="sidebar sidebar-dark sidebar-main sidebar-fixed  sidebar-expand-md">

        <!-- Sidebar mobile toggler -->
        <div class="sidebar-mobile-toggler text-center">
            <a href="#" class="sidebar-mobile-main-toggle">
                <i class="icon-arrow-left8"></i>
            </a>
            Navigation
            <a href="#" class="sidebar-mobile-expand">
                <i class="icon-screen-full"></i>
                <i class="icon-screen-normal"></i>
            </a>
        </div>
        <!-- /sidebar mobile toggler -->


        <!-- Sidebar content -->
        <div class="sidebar-content">

            <!-- Main navigation -->
            <div class="card card-sidebar-mobile pb-5" >
                <ul class="nav nav-sidebar" data-nav-type="accordion">

                    <!-- Main -->
                    

                    <li class="nav-item">
                        <router-link :to="{ name : 'dashboard' }" active-class="active" class="nav-link" >
                            <i class="icon-home4"></i> <span>Dashboard</span>
                        </router-link>
                    </li>

                     <li class="nav-item">
                        <router-link :to="{ name : 'users' }" v-bind:class="[ this.isUsersActive ? 'active' : '']"  active-class="active" class="nav-link" >
                            <i class="icon-users"></i> <span>Users</span>
                        </router-link>
                    </li>

                </ul>

            </div>
            <!-- /main navigation -->


        </div>
        <!-- /sidebar content -->

    </div>
    <!-- /main sidebar -->
</template>
<script>

export default{
	name : 'sidebar',
	data () {
		return {}
	},
    watch: {
        '$route' (to, from){},
    },
    mounted(){
        this.$store.dispatch('page/setSidebar');
    },
    beforeDestroy(){
        this.$store.dispatch('page/removeSidebar');
    },
    computed : {

        isUsersActive(){
            return [
                'users',
                'users-view',
                'users-add',
                'users-edit',
            ].includes(this.$route.name);
        },
 
        
    }


}

</script>